import axios from "axios";

export const state = {
    dividendpayouts: [],
};

export const getters = {
    dividendpayouts: state => state.dividendpayouts,
};

export const mutations = {
    setPayouts(state, newValue) {
        state.dividendpayouts = newValue
    },
};

export const actions = {
    async fetchDividendPayouts({ commit }) {
        await axios.get('/dividendpayouts').then(res => {
            commit('setPayouts', res.data.payouts)
        })
    },
    filterDividendPayouts({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterdividendpayouts";
        axios.post(url, formData).then((response) => {
            commit('setPayouts', response.data.payouts)
        })
    },
};
